import addPanelDataConsts from '@/addPanelDataConsts';
import type { EditorAPI } from '@/editorAPI';
import * as addPanel from '@/oldAddPanel';
import {
  onClickToContainer,
  onDropToContainer,
} from '../../contact/wixForms/utils';
import getFifthItemExtension from './fifthItem';
import getFirstItemExtension from './firstItem';
import getFourthItemExtension from './fourthItem';
import getSecondItemExtension from './secondItem';
import getThirdItemExtension from './thirdItem';

export default (
  editorAPI: EditorAPI,
  categoryId: string = addPanelDataConsts.CATEGORIES_ID.POPUP,
) => {
  const { popupSubscribeSection } = addPanel.sections.getSections().popup;
  const sectionTitle = popupSubscribeSection.title;
  const onDrop = onDropToContainer(categoryId, sectionTitle).bind(
    null,
    editorAPI,
  );
  const onClick = onClickToContainer(categoryId, sectionTitle).bind(
    null,
    editorAPI,
  );
  const itemsExtensions = [
    getFirstItemExtension(onDrop, onClick),
    getSecondItemExtension(onDrop, onClick),
    getThirdItemExtension(onDrop, onClick),
    getFourthItemExtension(onDrop, onClick),
    getFifthItemExtension(onDrop, onClick),
  ];

  return addPanel.dataUtil.extendPropsItems(
    popupSubscribeSection,
    itemsExtensions,
  );
};
